const CVIShipmentInsurance = () => {
    return (
        <div>

            <div className="flex flex-col justify-center items-center">
            <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
            <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
                
                    <div className="flex flex-col justify-center lg:max-w-[25rem] md:w-[30rem]">
                        <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                            Customer Voluntary Insurance
                        </h1>
                        <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                        CVI is a voluntary optional service that allows customers to insure the delivery of important goods. 
                        It provides an insurance cover in case of loss or damage to the customer’s package en route.
                        </p>
                        
                            
                    </div>
                    <div className="flex-1 flex flex-col justify-center sm:mt-[0rem] mt-[1rem]">
                    <img src="/financial-services/customerinsurance.jpg" alt="" className="max-w-[100%] rounded-md"/>
                    </div>
                </div>

            </div>
        </div>
    )
};
export default CVIShipmentInsurance;